// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LaunchBuild page — page-specific styles extracted from inline styles.
   Generic app-wide styles live in css/common.css. */

.launchbuild { padding: 20px; }

.lb-diagram-frame {
  width: 100%;
  height: 600px;
  border: 0;
  border-radius: 8px;
  background: #fff;
}

.lb-diagram-wrap { max-width: 600px; }

.lb-diagram-img {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.lb-hint { font-size: 14px; margin-bottom: 10px; }

.lb-search {
  padding: 8px;
  font-size: 14px;
  width: 300px;
  margin-bottom: 16px;
}

.lb-pagination { margin-top: 10px; text-align: center; }

/* Static part of the pagination button; the active background/color stays inline
   (it depends on the current page). */
.lb-page-btn {
  margin: 0 4px;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.lb-launch-row { margin-top: 20px; }

/* Static part of the launch button; backgroundColor/cursor stay inline (they
   depend on whether enough files are selected). */
.lb-launch-btn {
  padding: 10px 20px;
  color: #fff;
  border: none;
  border-radius: 5px;
}

.lb-modal-actions { display: flex; gap: 10px; justify-content: center; }

.lb-btn-yes {
  padding: 10px;
  background-color: #4CAF50;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.lb-btn-no {
  padding: 10px;
  background-color: #FF4B4B;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/css/LaunchBuild.css"],"names":[],"mappings":"AAAA;oDACoD;;AAEpD,eAAe,aAAa,EAAE;;AAE9B;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,WAAW,eAAe,EAAE,mBAAmB,EAAE;;AAEjD;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE;;AAEvD;sCACsC;AACtC;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB,gBAAgB,EAAE;;AAEnC;kDACkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;;AAEvE;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* LaunchBuild page — page-specific styles extracted from inline styles.\n   Generic app-wide styles live in css/common.css. */\n\n.launchbuild { padding: 20px; }\n\n.lb-diagram-frame {\n  width: 100%;\n  height: 600px;\n  border: 0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.lb-diagram-wrap { max-width: 600px; }\n\n.lb-diagram-img {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.lb-hint { font-size: 14px; margin-bottom: 10px; }\n\n.lb-search {\n  padding: 8px;\n  font-size: 14px;\n  width: 300px;\n  margin-bottom: 16px;\n}\n\n.lb-pagination { margin-top: 10px; text-align: center; }\n\n/* Static part of the pagination button; the active background/color stays inline\n   (it depends on the current page). */\n.lb-page-btn {\n  margin: 0 4px;\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.lb-launch-row { margin-top: 20px; }\n\n/* Static part of the launch button; backgroundColor/cursor stay inline (they\n   depend on whether enough files are selected). */\n.lb-launch-btn {\n  padding: 10px 20px;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n}\n\n.lb-modal-actions { display: flex; gap: 10px; justify-content: center; }\n\n.lb-btn-yes {\n  padding: 10px;\n  background-color: #4CAF50;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.lb-btn-no {\n  padding: 10px;\n  background-color: #FF4B4B;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
